import { render, staticRenderFns } from "./SubWebmasterBlockAccountModal.vue?vue&type=template&id=58b8a5b9&scoped=true"
import script from "./SubWebmasterBlockAccountModal.vue?vue&type=script&lang=js"
export * from "./SubWebmasterBlockAccountModal.vue?vue&type=script&lang=js"
import style0 from "./SubWebmasterBlockAccountModal.vue?vue&type=style&index=0&id=58b8a5b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b8a5b9",
  null
  
)

export default component.exports